document.addEventListener("DOMContentLoaded", () => {
    // Βρίσκει όλα τα links με το ?pr_prod_strat=
    const links = document.querySelectorAll('a[href*="?pr_prod_strat="]');
    
    // Αφαιρεί τις παραμέτρους από κάθε link
    links.forEach(link => {
        const url = new URL(link.href);
        url.searchParams.delete('pr_prod_strat');
        link.href = url.toString();
    });
});
